/** Hindi: the card interview: the questions, retries, readbacks, checks and summary, and its chips. */
export const interview = {
    "iv.start": "चलिए, आपका कार्ड बनाते हैं। मैं कुछ सवाल पूछूँगा; बोलकर या लिखकर जवाब दीजिए।",
    "iv.ask.trade": "आप कौन-सा काम करते हैं?",
    "iv.ask.area": "आप किस इलाक़े में काम करते हैं?",
    "iv.ask.rate_month": "आप आम तौर पर महीने का कितना लेते हैं?",
    "iv.ask.rate_visit": "एक बार आने का आम तौर पर कितना लेते हैं?",
    "iv.ask.min": "सबसे कम कितने में करेंगे? यह किसी और को नहीं दिखेगा।",
    "iv.band_month": "{city} में {trade}: आम तौर पर महीने का {low}–{high}।",
    "iv.band_visit": "{city} में {trade}: आम तौर पर एक बार का {low}–{high}।",
    "iv.band_none": "{trade}: इस काम की आम रेंज अभी हमारे पास नहीं है।",
    "iv.legal_min": "{trade} के लिए, रोज़ {hours} घंटे के काम का कानूनी न्यूनतम: महीने का {min}।",
    "iv.band_seed": "सार्वजनिक स्रोतों से जुटाया गया, अभी किसी यूनियन ने जाँचा नहीं है।",
    "iv.ask.languages": "{lang} के अलावा आप कौन-सी भाषाएँ बोलते हैं?",
    "iv.ask.about": "ग्राहकों के लिए अपने काम के बारे में एक लाइन बताइए, या 'छोड़ो' कहिए।",
    "iv.ask.ask_first": "जहाँ {item} हों, वहाँ दाम बताने से पहले आपसे पूछूँ?",
    "iv.ask.auto": "ग्राहक आपके दामों के अंदर मान जाए, तो क्या मैं आपकी ओर से सौदा पक्का कर दूँ?",
    "iv.again.trade": "काम का नाम कुछ शब्दों में बोलिए, जैसे खाना बनाना, बिजली का काम या दर्ज़ी।",
    "iv.again.area": "इलाक़े का नाम बोलिए, या नीचे दबाइए।",
    "iv.again.amount": "रुपयों में रक़म बोलिए, जैसे आठ हज़ार।",
    "iv.again.yes_no": "हाँ या नहीं बोलिए।",
    "iv.again.languages": "किसी भाषा का नाम बोलिए, या 'कोई नहीं' कहिए।",
    "iv.check_amount": "क्या आपने {price} कहा?",
    "iv.got_rate": "आम दाम {price}, नोट कर लिया।",
    "iv.got_min": "सबसे कम {price}, नोट कर लिया। यह किसी और को नहीं दिखेगा।",
    "iv.err_min": "सबसे कम दाम आपके आम दाम {price} से ज़्यादा नहीं हो सकता। फिर से बोलिए।",
    "iv.err_private": "यह फ़ोन नंबर या यूपीआई आईडी जैसा लगता है। कार्ड सबको दिखता है, इसलिए इसे मत डालिए।",
    "iv.err_long": "एक छोटी लाइन में बताइए।",
    "iv.summary": "आपका कार्ड: {area} में {trades}, आम दाम {rate}।",
    "iv.summary_about": 'ग्राहक यह पढ़ेंगे: "{about}"',
    "iv.summary_auto_on": "ग्राहक आपके दामों के अंदर मान जाए, तो मैं आपकी ओर से दस्तख़त कर दूँगा।",
    "iv.summary_auto_off": "कोई भी सौदा पक्का करने से पहले मैं आपसे पूछूँगा।",
    "iv.summary_min": "आपका सबसे कम दाम: {min}। यह सिर्फ़ इसी फ़ोन पर रहेगा।",
    "iv.confirm": "क्या इसे बोर्ड पर लगा दूँ?",
    "iv.what_change": "क्या बदलूँ?",
    "iv.published": "हो गया। अब {area} के आस-पास के ग्राहक आपको ढूँढ सकते हैं।",
    "iv.skip": "छोड़ें",
    "iv.none": "और कोई नहीं",
    "iv.later": "बाद में",
    "iv.resume": "कार्ड बनाना जारी रखें",
    "iv.by_voice": "बोलकर भरें",
};
//# sourceMappingURL=interview.js.map